import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Bs4GenericField from './Bs4GenericField';
import bs4OptionBinding from '../../Bs4OptionBinding'

export default class Bs4InfinityGrid extends Bs4GenericField {  

  initializeFormField() {
    super.initializeFormField()

    this.bs4Option = bs4OptionBinding({
      bs4Source: 'Bs4InfinityGrid',
      bs4KartotekaId: this.bs4KartotekaId,
      optionId: this.props.field.idSourceReport,
      optionType:'infinity',
      formId: this.props.field.formId,
      bs4flexframe: this.props.bs4flexframe,
      field: this.props.field,
      noSelectableCheckbox: true,
    });
  }
  
  bs4flexframeHeight = true;

  ViewComponentGrid = () => {
    const formField = this;
    return (
      <formField.bs4Option.ViewComponent/>      
    );
  }

  ViewComponentField = () => {
    const formField = this;
    //console.log('... infinity ...', this)
    if (this.props.field.hideLabel) return <formField.ViewComponentGrid/>     
    else return (
      <FormControl id={this.props.inputId} fullWidth sx={{height: this.props.bs4flexframe ? '100%' : 'auto'}} >
        <FormLabel><formField.Bs4Label/></FormLabel>
        <formField.ViewComponentGrid/>
      </FormControl>
    );
  }
}